export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-gradient-to-br from-primary-500 via-primary-600 to-primary-700">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-5">
              <i className="ri-smartphone-line"></i>
              <span className="whitespace-nowrap">移动端专属体验</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-background-50">白云视频App · 掌上影院</h2>
            <p className="mt-4 text-base text-background-50/85 leading-relaxed max-w-lg mx-auto lg:mx-0">
              专为手机优化的高清视频播放器，支持苹果视频、榴莲视频同款播放体验。海量影视资源一站聚合，智能推荐你爱看的内容，随时随地开启观影之旅。支持离线缓存、倍速播放、弹幕互动等丰富功能，让手机看片更有趣。
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50/15 text-background-50 text-sm">
                <i className="ri-apple-fill text-lg"></i>
                <span className="whitespace-nowrap">iOS 版</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50/15 text-background-50 text-sm">
                <i className="ri-android-fill text-lg"></i>
                <span className="whitespace-nowrap">Android 版</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50/15 text-background-50 text-sm">
                <i className="ri-computer-line text-lg"></i>
                <span className="whitespace-nowrap">Web 网页版</span>
              </div>
            </div>
            <div className="mt-6">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-primary-600 font-semibold text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-cloud-2-line text-lg"></i>
                下载白云视频App
              </a>
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-[240px] h-[460px] md:w-[280px] md:h-[520px]">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20video%20player%20app%20interface%20with%20movie%20playback%20screen%20showing%20a%20cinematic%20scene%2C%20play%20button%20overlay%2C%20progress%20bar%20and%20control%20buttons%20at%20bottom%2C%20warm%20coral%20and%20dark%20color%20scheme%2C%20modern%20minimal%20UI%20design%2C%20clean%20phone%20frame%2C%20high%20quality%20product%20photography%20style%20with%20soft%20lighting%20on%20gradient%20background&width=560&height=1040&seq=app-phone-screen&orientation=portrait"
                alt="白云视频App播放界面"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}